import { render, staticRenderFns } from "./CreateContent.vue?vue&type=template&id=9a8f615a&"
import script from "./CreateContent.vue?vue&type=script&lang=js&"
export * from "./CreateContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports